import { Component, output } from '@angular/core';
import { UpdateComponentBaseWithEditItems } from '../../UpdateComponentBaseWithEditItems.js';

import { Asset, AssetKey, LocalizedTextIds } from 'company-finder-common';
@Component({
	selector: 'assets-update',
	templateUrl: './assets-update.component.html',
	styleUrls: ['./assets-update.component.scss'],
	standalone: false,
})
export class AssetsUpdateComponent extends UpdateComponentBaseWithEditItems {
	public onAssetSelected = output<Asset>();

	public get header(): string {
		return this.Loc(this.LocalizedTextIds.Assets);
	}

	public openAsset(asset?: Asset): void {
		this.assetToModify = asset;
		this.onAssetSelected.emit(asset);
	}

	public get assetToModify(): Asset {
		return this.updateService.assetToModify;
	}

	public set assetToModify(value: Asset) {
		this.updateService.assetToModify = value;
	}

	public get assetsTitle(): string {
		return this.Loc(LocalizedTextIds.Assets);
	}

	public get assetColumns(): AssetKey[] {
		return [
			'name',
			'focusArea',
			'therapeuticArea',
			'indication',
			'target',
			'routeOfAdministration',
			'developmentStage',
		];
	}
}
